import { render, staticRenderFns } from "./MetricsEmployeeProjectsKPI.vue?vue&type=template&id=0ddd49d7&scoped=true"
import script from "./MetricsEmployeeProjectsKPI.vue?vue&type=script&lang=js"
export * from "./MetricsEmployeeProjectsKPI.vue?vue&type=script&lang=js"
import style0 from "./MetricsEmployeeProjectsKPI.vue?vue&type=style&index=0&id=0ddd49d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddd49d7",
  null
  
)

export default component.exports